export const imask = {
  methods: {
    imaskOnAccept(e, formInputKey) {
      const maskRef = e.detail;
      this.formInput[formInputKey] = maskRef.value;
      console.log("accept", maskRef.value);
    },
    imaskOnComplete(e) {
      const maskRef = e.detail;
      console.log("complete", maskRef.unmaskedValue);
    },
    async imaskOnChange(e) {
      console.log("change", e);
      const inputElement = await e.target.getInputElement();
      if (inputElement.value !== e.detail.value) {
        inputElement.value = e.detail.value;
      }
    },
  },
};
